import { render, staticRenderFns } from "./PurchaseVolumeStatistics.vue?vue&type=template&id=3562997b&"
import script from "./PurchaseVolumeStatistics.vue?vue&type=script&lang=ts&"
export * from "./PurchaseVolumeStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseVolumeStatistics.vue?vue&type=style&index=0&id=3562997b&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports